// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RKHmR","controls":"styles_controls__oBi8d","charLimit":"styles_charLimit__1BRDp","input":"styles_input__1UtK1","send":"styles_send__16kF3"};